<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row>
      <v-col cols="12" sm="10" md="8" lg="6" class="mx-auto">
      	
      	<v-card class="shadowCard">
      	  <v-card-title class="text-subtitle-1">
      	    Encuesta de Opinión Docente
      	    <v-spacer></v-spacer>

      	    <!-- Botón par aexportar -->
            <!-- <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportar()"
            >
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
            -->
            
      	  	<!-- Botón para consultar la iformación al sistema -->
      	    <v-btn 
              small dark color="primary"
              @click="consultar()"
            >
              Consultar
            </v-btn>

      	  </v-card-title>

      	  <!-- Tabla y filtros -->
      	  <v-card-text>

            <!-- Filtro de ciclos -->
            <v-row>
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  persistent-hint
                  item-text="ciclo"
                  item-value="id_ciclo"
                >
                </v-autocomplete>
              </v-col>
            </v-row>


            <div
              v-if="encuestaEnviada"
              class="encuesta-status encuesta-status--exito mb-3"
            >
              <div class="encuesta-status__accent"></div>
              <div class="encuesta-status__icon">
                <v-icon size="24" color="#059669">mdi-check-circle-outline</v-icon>
              </div>
              <div class="encuesta-status__content">
                <div class="encuesta-status__eyebrow">Encuesta completada</div>
                <div class="encuesta-status__title">¡Gracias por tu participación!</div>
                <p class="encuesta-status__text mb-0">
                  Tu respuesta fue registrada correctamente. Ya no es posible contestar de nuevo en este ciclo.
                </p>
              </div>
            </div>

            <template v-else>
              <div
                v-if="mensajeVentana"
                class="encuesta-status encuesta-status--pendiente mb-3"
              >
                <div class="encuesta-status__accent"></div>
                <div class="encuesta-status__icon">
                  <v-icon size="24" color="#d97706">mdi-calendar-clock-outline</v-icon>
                </div>
                <div class="encuesta-status__content">
                  <div class="encuesta-status__eyebrow">Periodo de aplicación</div>
                  <div class="encuesta-status__title">
                    {{ ventanaPendiente ? 'La encuesta aún no abre' : 'La encuesta ya cerró' }}
                  </div>
                  <p class="encuesta-status__text mb-0">{{ mensajeVentana }}</p>
                  <div v-if="ventanaEncuesta" class="encuesta-status__meta mt-3">
                    <span class="encuesta-status__pill">
                      <v-icon x-small class="mr-1">mdi-calendar-range</v-icon>
                      {{ rangoVentanaTexto() }}
                    </span>
                    <span v-if="ventanaEncuesta.semana_aplicacion" class="encuesta-status__pill encuesta-status__pill--soft">
                      Semana {{ ventanaEncuesta.semana_aplicacion }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                v-if="mostrarSinPreguntas"
                class="encuesta-status encuesta-status--aviso mb-3"
              >
                <div class="encuesta-status__accent"></div>
                <div class="encuesta-status__icon">
                  <v-icon size="24" color="#94a3b8">mdi-database-alert-outline</v-icon>
                </div>
                <div class="encuesta-status__content">
                  <div class="encuesta-status__eyebrow">Base de datos</div>
                  <div class="encuesta-status__title">Sin preguntas para este ciclo</div>
                  <p class="encuesta-status__text mb-0">
                    No hay preguntas disponibles. Verifica que el script de la encuesta esté aplicado en base de datos.
                  </p>
                </div>
              </div>
            </template>

            <div
              v-if="puedeMostrarPreguntas"
              class="encuesta-status encuesta-status--info mb-3"
            >
              <div class="encuesta-status__accent"></div>
              <div class="encuesta-status__icon encuesta-status__icon--sm">
                <v-icon size="22" color="#3b82f6">mdi-information-outline</v-icon>
              </div>
              <div class="encuesta-status__content">
                <div class="encuesta-status__title encuesta-status__title--sm">Instrucciones</div>
                <p class="encuesta-status__text mb-0">
                  Selecciona la opción que mejor describa cómo te sientes hoy en la escuela.
                  Esta encuesta es <strong>confidencial</strong> y busca identificar puntos operativos a mejorar.
                </p>
              </div>
            </div>

            <template v-if="puedeMostrarPreguntas">
            <template v-for="(categoria, i) in categorias">
              <div
                v-for="(pregunta, j) in categoria.preguntas"
                :key="'preg-' + i + '-' + j"
                class="encuesta-pregunta-wrap mb-3"
              >
                <v-card flat class="encuesta-pregunta-card pa-4">
                  <div class="text-center">
                    <v-chip x-small color="primary" outlined class="mb-2">
                      Pregunta {{ numeroPregunta(pregunta, j) }} de {{ totalPreguntas }}
                    </v-chip>

                    <div class="encuesta-tema text-subtitle-1 font-weight-bold mb-2">
                      {{ numeroPregunta(pregunta, j) }}. {{ tituloTema(pregunta) }}
                    </div>

                    <div class="encuesta-pregunta-text text-body-1 font-weight-medium mb-4">
                      {{ textoPregunta(pregunta) }}
                    </div>

                    <template v-if="pregunta.tipo_pregunta == 1">
                      <div
                        v-if="!opcionesPregunta(pregunta).length"
                        class="encuesta-status encuesta-status--aviso encuesta-status--compact text-left my-2"
                      >
                        <div class="encuesta-status__icon encuesta-status__icon--xs">
                          <v-icon size="18" color="white">mdi-alert-circle-outline</v-icon>
                        </div>
                        <div class="encuesta-status__content">
                          <p class="encuesta-status__text mb-0">
                            Faltan opciones en base de datos para esta pregunta.
                          </p>
                        </div>
                      </div>
                      <div v-else class="encuesta-opciones">
                        <div
                          v-for="(opcion, k) in opcionesPregunta(pregunta)"
                          :key="'op-' + i + '-' + j + '-' + k"
                          class="encuesta-opcion-item"
                          :class="{ 'encuesta-opcion-item--active': emojiActivo(pregunta, opcion) }"
                          @click="seleccionarOpcion(pregunta, opcion)"
                        >
                          <ul class="feedback encuesta-feedback mb-0">
                            <li :class="claseEmoji(k, pregunta, opcion)">
                              <div>
                                <template v-if="k !== 2">
                                  <svg class="eye left"><use xlink:href="#eye"></use></svg>
                                  <svg class="eye right"><use xlink:href="#eye"></use></svg>
                                </template>
                                <svg v-if="k !== 2 && k !== 4" class="mouth"><use xlink:href="#mouth"></use></svg>
                              </div>
                            </li>
                          </ul>
                          <div class="encuesta-opcion-etiqueta">{{ opcion.etiqueta }}</div>
                        </div>
                      </div>
                      <v-expand-transition>
                        <div
                          v-if="descripcionSeleccionada(pregunta)"
                          class="text-body-2 mt-3 grey--text text--darken-2 encuesta-seleccion"
                        >
                          {{ descripcionSeleccionada(pregunta) }}
                        </div>
                      </v-expand-transition>
                    </template>

                    <v-textarea
                      v-else
                      v-model="pregunta.texto"
                      filled
                      dense
                      :rows="3"
                      auto-grow
                      label="Tu respuesta (opcional)"
                      hide-details
                      class="mt-2 encuesta-texto-abierto"
                    ></v-textarea>
                  </div>
                </v-card>
              </div>
            </template>
            </template>

            <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
              <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
                <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1"></path>
              </symbol>
              <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 7" id="mouth">
                <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5"></path>
              </symbol>
            </svg>

      	  </v-card-text>
      	  <v-card-actions>
			      <v-spacer></v-spacer>
			      <v-btn
			        color="primary"
			        depressed
			        @click="save()"
			        dense
			        rounded
			        :disabled="!puedeMostrarPreguntas || encuestaEnviada"
			      >
			        Enviar encuesta
			      </v-btn>
			    </v-card-actions>
      	</v-card>

      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import VueApexCharts         from 'vue-apexcharts'

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import { idCicloSugeridoEncuestaAmbiente, buildVentanaEncuestaAmbiente, enVentanaAmbiente, mensajeFueraDeVentana } from '@/helpers/encuesta-ambiente-ventana'


  export default {

  	components:{
      Alerta,
      carga,
      VueApexCharts
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      ciclos:[],
      ciclo:null,

      dialogReemplazo: false,

      // Filtros avanzados

      teachersFiltros:[],
			teacherFilter: null,

			dialogMaestro: false,

			escuela: 1,

			categorias:[],

      encuestaEnviada: false,

      ventanaEncuesta: null,
      mensajeVentana: '',
      encuestaConsultada: false,

      jefePuesto: null,
    }),

    computed: {
    	...mapGetters("login", ["getdatosUsuarioERPERP", "getLogeado"]),

      totalPreguntas () {
        let total = 0
        for ( const categoria of this.categorias ) {
          total += ( categoria.preguntas || [] ).length
        }
        return total
      },

      ventanaPendiente () {
        if ( !this.ventanaEncuesta || !this.ventanaEncuesta.fecha_inicio ) return true
        const hoy = this.fechaHoyYmd()
        return hoy < this.ventanaEncuesta.fecha_inicio
      },

      fueraDeVentana () {
        if ( this.mensajeVentana ) return true
        if ( !this.ventanaEncuesta ) return false
        return !enVentanaAmbiente( this.ventanaEncuesta, this.fechaHoyYmd() )
      },

      puedeMostrarPreguntas () {
        return Boolean(
          this.ciclo &&
          !this.encuestaEnviada &&
          !this.fueraDeVentana &&
          this.categorias.length
        )
      },

      mostrarSinPreguntas () {
        return Boolean(
          this.ciclo &&
          this.encuestaConsultada &&
          !this.fueraDeVentana &&
          !this.categorias.length &&
          !this.encuestaEnviada
        )
      },
  	},

    watch: {
      // Consultar cuando haya un cambio en el ciclo y este sea un ciclo seleccionado y no un ciclo vacio
      ciclo () {
        if(this.ciclo){
          this.consultar()
        }
      }
    },

    async created () {
      await this.initialize()
    },

    methods: {
      // Funcion para cargar datos iniciales
      initialize () {
      	this.cargar = true
        // Vaciar los ciclos
        this.ciclos = []
        // Obtener todos los ciclos
        this.$http.get('roles.ciclos.all').then(response=>{
          // hacer un ciclo ya que los ciclos vienen varios como inscripciones y todo eso
          // y solo queremos los ciclos que en su nombre dicen ciclo 
          for(const i in response.data){
            //  si es diferente a FE
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              // Y es igual a FE, se agrega a ciclos
              // por qué es diferente a FE? por que es por estetica, mostrar solo los ciclos normales, ya que los ciclos tienen ligado el ciclo FE
              if(response.data[i].ciclo.search('CICLO') != -1){
                this.ciclos.push(response.data[i])
              }
            }
          }

          const cicloSugerido = idCicloSugeridoEncuestaAmbiente(this.ciclos)
          if (cicloSugerido) {
            this.ciclo = cicloSugerido
          }

      		this.cargar = false

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      obtenerCicloSeleccionado () {
        if ( !this.ciclo ) return null
        if ( typeof this.ciclo === 'object' ) return this.ciclo
        return this.ciclos.find( ( c ) => Number( c.id_ciclo ) === Number( this.ciclo ) ) || null
      },

      aplicarBloqueoVentana ( cicloRow ) {
        const ventana = buildVentanaEncuestaAmbiente( cicloRow )
        this.ventanaEncuesta = ventana
        if ( !ventana || !enVentanaAmbiente( ventana, this.fechaHoyYmd() ) ) {
          this.mensajeVentana = mensajeFueraDeVentana( ventana, this.fechaHoyYmd() )
          this.categorias = []
          this.jefePuesto = null
          return false
        }
        this.mensajeVentana = ''
        return true
      },

      consultar () {

        if( !this.ciclo  ){
          return this.validarErrorDirecto('Favor de seleccionar un cuclo')
        }

        const cicloRow = this.obtenerCicloSeleccionado()
        if ( !cicloRow ) {
          return this.validarErrorDirecto( 'No se encontró el ciclo seleccionado.' )
        }

      	const payload = {
      		id_usuario  : this.getdatosUsuarioERPERP.iderp,
          id_ciclo    : cicloRow.id_ciclo,
          id_puesto   : this.getdatosUsuarioERPERP.idpuesto,
          id_plantel  : this.getdatosUsuarioERPERP.id_plantel
      	}
      	
      	this.categorias = []
        this.encuestaEnviada = false
        this.ventanaEncuesta = null
        this.mensajeVentana = ''
        this.encuestaConsultada = false

        if ( !this.aplicarBloqueoVentana( cicloRow ) ) {
          this.encuestaConsultada = true
          return
        }

      	this.cargar = true
        this.$http.post('encuestas.ambiente', payload ).then(response=>{
          if ( !this.aplicarBloqueoVentana( cicloRow ) ) {
            this.encuestaConsultada = true
            return
          }
          this.categorias         = response.data.encuesta
          this.jefePuesto         = response.data.jefePuesto
          this.ventanaEncuesta    = response.data.ventana || this.ventanaEncuesta
          this.mensajeVentana    = ''
          this.cargar      = false
        }).catch( error =>{
          const mensaje = error.response && error.response.data && error.response.data.message
          const ventana = error.response && error.response.data && error.response.data.ventana
          if ( ventana ) {
            this.ventanaEncuesta = ventana
            this.mensajeVentana = mensaje || ''
            this.categorias = []
            this.jefePuesto = null
            return
          }
          if ( mensaje && /ya tienes una encuesta|encuesta ya realizada/i.test( mensaje ) ) {
            this.encuestaEnviada = true
            this.categorias = []
            this.jefePuesto = null
            return
          }
          this.validarError( mensaje || error )
        }).finally( () => {
          this.encuestaConsultada = true
          this.cargar = false
        })
      },

      fechaHoyYmd () {
        const d = new Date()
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      },

      formatoFechaCorta ( ymd ) {
        if ( !ymd ) return ''
        const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number)
        const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
        return `${d} ${meses[m - 1]} ${y}`
      },

      rangoVentanaTexto () {
        if ( !this.ventanaEncuesta ) return ''
        const { fecha_inicio, fecha_fin } = this.ventanaEncuesta
        return `${this.formatoFechaCorta(fecha_inicio)} – ${this.formatoFechaCorta(fecha_fin)}`
      },

      exportarPreguntas(){
      	this.exportExcel( this.data  , 'preguntas_abiertas')
      },

      exportar( ){
      	this.exportExcel( this.filterGrupos  , 'ROL_CLASES')
      },

      validarEncuestaCompleta () {
        for ( const categoria of this.categorias ) {
          for ( const pregunta of ( categoria.preguntas || [] ) ) {
            if ( Number( pregunta.tipo_pregunta ) === 1 && !Number( pregunta.valor ) ) {
              const numero = pregunta.numero_pregunta ? ` (${ pregunta.numero_pregunta })` : ''
              return `Favor de responder la pregunta${ numero }: ${ this.textoPregunta( pregunta ) }`
            }
          }
        }
        return null
      },

      tituloTema ( pregunta ) {
        const texto = pregunta.pregunta || ''
        const partes = texto.split(' — ')
        return partes[0] || texto
      },

      textoPregunta ( pregunta ) {
        if ( pregunta.subtitulo ) return pregunta.subtitulo
        const texto = pregunta.pregunta || ''
        const partes = texto.split(' — ')
        return partes.length > 1 ? partes.slice( 1 ).join(' — ') : texto
      },

      numeroPregunta ( pregunta, index ) {
        return pregunta.numero_pregunta || ( index + 1 )
      },

      emojiActivo ( pregunta, opcion ) {
        return Number( pregunta.valor ) === Number( opcion.valor )
      },

      opcionesPregunta ( pregunta ) {
        return ( pregunta.opciones || [] ).slice().sort( ( a, b ) => ( a.orden || 0 ) - ( b.orden || 0 ) )
      },

      claseEmoji ( index, pregunta, opcion ) {
        const clases = ['angry', 'sad', 'ok', 'good', 'happy']
        const base = clases[index] || 'ok'
        const activo = Number( pregunta.valor ) === Number( opcion.valor )
        return `${ base }${ activo ? ' active' : '' }`
      },

      seleccionarOpcion ( pregunta, opcion ) {
        pregunta.valor = Number( opcion.valor )
      },

      descripcionSeleccionada ( pregunta ) {
        const valor = Number( pregunta.valor )
        if ( !valor ) return ''
        const opcion = this.opcionesPregunta( pregunta ).find( o => Number( o.valor ) === valor )
        if ( !opcion ) return ''
        return opcion.descripcion || opcion.etiqueta
      },

      save () {

        if( !this.ciclo  ){
          return this.validarErrorDirecto('Favor de seleccionar un ciclo')
        }

        const cicloRow = this.obtenerCicloSeleccionado()
        if ( !cicloRow || !this.aplicarBloqueoVentana( cicloRow ) ) {
          return this.validarErrorDirecto( this.mensajeVentana || 'La encuesta no está disponible en este momento.' )
        }

        const errorValidacion = this.validarEncuestaCompleta()
        if ( errorValidacion ) {
          return this.validarErrorDirecto( errorValidacion )
        }

        const payload = {
          id_usuario  : this.getdatosUsuarioERPERP.iderp,
          id_ciclo    : cicloRow.id_ciclo,
          categorias  : this.categorias,
        }
        
        this.cargar = true
        this.$http.post('encuestas.ambiente.add', payload ).then(response=>{
          this.categorias = []
          this.jefePuesto = null
          this.encuestaEnviada = true
          this.validarSuccess( response.data.message || 'Encuesta realizada correctamente' )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

    },
  }

</script>
<style>
  .v-data-table__wrapper{

  }

  .v-data-table__wrapper::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-data-table__wrapper::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-button:increment,.v-data-table__wrapper::-webkit-scrollbar-button{
    display: none;
  }

  .v-data-table__wrapper::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

	.text-gradient{
		color: #82d616!important;
	}

  .text-typo {
    color: #344767!important;
	}

	.check {
	  position: absolute;
	  top: -10px;
	  right: 90px;
	  width: 30px;
	}


	.v-btn--example {
    bottom: 0;
    position: absolute;
    margin: 0 0 16px 16px;
    right: 10px;
  }
  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }
  
  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }


  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button:increment,.v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button{
    display: none;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  .feedback {
    --normal: #ECEAF3;
    --normal-shadow: #D9D8E3;
    --normal-mouth: #9795A4;
    --normal-eye: #595861;
    --active: #F8DA69;
    --active-shadow: #F4B555;
    --active-mouth: #F05136;
    --active-eye: #313036;
    --active-tear: #76b5e7;
    --active-shadow-angry: #e94f1d;
    margin: 0 auto;
    padding: 0;
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .encuesta-pregunta-wrap {
    max-width: 620px;
    margin: 0 auto;
  }

  .encuesta-status {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid #eef2f6;
    overflow: hidden;
    background: #fcfdfe;
    box-shadow: none;
  }

  .encuesta-status__accent {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
  }

  .encuesta-status__icon {
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    border: 1px solid #eef2f6;
    box-shadow: none;
  }

  .encuesta-status__icon--sm {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }

  .encuesta-status__icon--xs {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    box-shadow: none;
  }

  .encuesta-status__content {
    flex: 1;
    min-width: 0;
    padding-top: 2px;
  }

  .encuesta-status__eyebrow {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    margin-bottom: 3px;
    opacity: 0.85;
  }

  .encuesta-status__title {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
    color: #334155;
    margin-bottom: 4px;
  }

  .encuesta-status__title--sm {
    font-size: 15px;
    margin-bottom: 4px;
  }

  .encuesta-status__text {
    font-size: 13px;
    line-height: 1.5;
    color: #64748b;
  }

  .encuesta-status__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .encuesta-status__pill {
    display: inline-flex;
    align-items: center;
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
  }

  .encuesta-status--pendiente {
    background: #fffef9;
    border-color: #f5ecd8;
  }

  .encuesta-status--pendiente .encuesta-status__accent {
    background: #f5d78e;
  }

  .encuesta-status--pendiente .encuesta-status__icon {
    background: #fffbeb;
    border-color: #f5ecd8;
  }

  .encuesta-status--pendiente .encuesta-status__eyebrow {
    color: #a68b4b;
  }

  .encuesta-status--pendiente .encuesta-status__pill {
    background: #fff;
    color: #92722d;
    border: 1px solid #f0e4c8;
  }

  .encuesta-status--pendiente .encuesta-status__pill--soft {
    background: #fffdf6;
    color: #a68b4b;
    border: 1px solid #f5ecd8;
  }

  .encuesta-status--exito {
    background: #f8fdfb;
    border-color: #d9f2e6;
  }

  .encuesta-status--exito .encuesta-status__accent {
    background: #86d9b3;
  }

  .encuesta-status--exito .encuesta-status__icon {
    background: #f0fdf7;
    border-color: #d9f2e6;
  }

  .encuesta-status--exito .encuesta-status__eyebrow {
    color: #3d8f6a;
  }

  .encuesta-status--aviso {
    background: #fafbfc;
    border-color: #e8edf2;
  }

  .encuesta-status--aviso .encuesta-status__accent {
    background: #cbd5e1;
  }

  .encuesta-status--aviso .encuesta-status__icon {
    background: #f8fafc;
    border-color: #e8edf2;
  }

  .encuesta-status--aviso .encuesta-status__eyebrow {
    color: #94a3b8;
  }

  .encuesta-status--info {
    background: #f8fbff;
    border-color: #e3edfa;
  }

  .encuesta-status--info .encuesta-status__accent {
    background: #93c5fd;
  }

  .encuesta-status--info .encuesta-status__icon {
    background: #eff6ff;
    border-color: #dbeafe;
    box-shadow: none;
  }

  .encuesta-status--compact {
    padding: 10px 12px;
    gap: 10px;
    box-shadow: none;
  }

  .encuesta-pregunta-card {
    background: #fafbfc !important;
    border: 1px solid #e8eaed;
    border-radius: 12px !important;
  }

  .encuesta-tema {
    color: #37474f;
  }

  .encuesta-pregunta-text {
    line-height: 1.5;
    max-width: 520px;
    margin: 0 auto;
    color: #1a1a1a;
  }

  .encuesta-opciones {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 4px 8px;
    margin: 0 auto;
    max-width: 520px;
  }

  .encuesta-opcion-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    width: 88px;
    padding: 4px 2px;
    border-radius: 8px;
    transition: background 0.2s;
  }

  .encuesta-opcion-item:hover {
    background: rgba(0, 0, 0, 0.03);
  }

  .encuesta-opcion-item--active {
    background: rgba(25, 118, 210, 0.08);
  }

  .encuesta-opcion-item .feedback {
    margin: 0;
  }

  .encuesta-opcion-etiqueta {
    font-size: 11px;
    line-height: 1.25;
    text-align: center;
    margin-top: 6px;
    color: #546e7a;
    font-weight: 500;
    max-width: 84px;
    word-wrap: break-word;
  }

  .encuesta-opcion-item--active .encuesta-opcion-etiqueta {
    color: #1565c0;
    font-weight: 700;
  }

  .encuesta-seleccion {
    max-width: 480px;
    margin: 0 auto;
    line-height: 1.4;
  }

  .encuesta-texto-abierto {
    max-width: 100%;
  }

  .feedback li {
    position: relative;
    border-radius: 50%;
    background: var(--sb, var(--normal));
    box-shadow: inset 3px -3px 4px var(--sh, var(--normal-shadow));
    transition: background 0.4s, box-shadow 0.4s, transform 0.3s;
    -webkit-tap-highlight-color: transparent;
  }
  .feedback li:not(:last-child) {
    margin-right: 20px;
  }
  .feedback li div {
    width: 44px;
    height: 44px;
    position: relative;
    transform: perspective(240px) translateZ(4px);
  }
  .feedback li div svg, .feedback li div:before, .feedback li div:after {
    display: block;
    position: absolute;
    left: var(--l, 9px);
    top: var(--t, 13px);
    width: var(--w, 8px);
    height: var(--h, 2px);
    transform: rotate(var(--r, 0deg)) scale(var(--sc, 1)) translateZ(0);
  }
  .feedback li div svg {
    fill: none;
    stroke: var(--s);
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
    transition: stroke 0.4s;
  }
  .feedback li div svg.eye {
    --s: var(--e, var(--normal-eye));
    --t: 17px;
    --w: 7px;
    --h: 4px;
  }
  .feedback li div svg.eye.right {
    --l: 23px;
  }
  .feedback li div svg.mouth {
    --s: var(--m, var(--normal-mouth));
    --l: 11px;
    --t: 23px;
    --w: 18px;
    --h: 7px;
  }
  .feedback li div:before, .feedback li div:after {
    content: "";
    z-index: var(--zi, 1);
    border-radius: var(--br, 1px);
    background: var(--b, var(--e, var(--normal-eye)));
    transition: background 0.4s;
  }
  .feedback li.angry {
    --step-1-rx: -24deg;
    --step-1-ry: 20deg;
    --step-2-rx: -24deg;
    --step-2-ry: -20deg;
  }
  .feedback li.angry div:before {
    --r: 20deg;
  }
  .feedback li.angry div:after {
    --l: 23px;
    --r: -20deg;
  }
  .feedback li.angry div svg.eye {
    stroke-dasharray: 4.55;
    stroke-dashoffset: 8.15;
  }
  .feedback li.angry.active {
    -webkit-animation: angry 1s linear;
            animation: angry 1s linear;
  }
  .feedback li.angry.active div:before {
    --middle-y: -2px;
    --middle-r: 22deg;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.angry.active div:after {
    --middle-y: 1px;
    --middle-r: -18deg;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.sad {
    --step-1-rx: 20deg;
    --step-1-ry: -12deg;
    --step-2-rx: -18deg;
    --step-2-ry: 14deg;
  }
  .feedback li.sad div:before, .feedback li.sad div:after {
    --b: var(--active-tear);
    --sc: 0;
    --w: 5px;
    --h: 5px;
    --t: 15px;
    --br: 50%;
  }
  .feedback li.sad div:after {
    --l: 25px;
  }
  .feedback li.sad div svg.eye {
    --t: 16px;
  }
  .feedback li.sad div svg.mouth {
    --t: 24px;
    stroke-dasharray: 9.5;
    stroke-dashoffset: 33.25;
  }
  .feedback li.sad.active div:before, .feedback li.sad.active div:after {
    -webkit-animation: tear 0.6s linear forwards;
            animation: tear 0.6s linear forwards;
  }
  .feedback li.ok {
    --step-1-rx: 4deg;
    --step-1-ry: -22deg;
    --step-1-rz: 6deg;
    --step-2-rx: 4deg;
    --step-2-ry: 22deg;
    --step-2-rz: -6deg;
  }
  .feedback li.ok div:before {
    --l: 12px;
    --t: 17px;
    --h: 4px;
    --w: 4px;
    --br: 50%;
    box-shadow: 12px 0 0 var(--e, var(--normal-eye));
  }
  .feedback li.ok div:after {
    --l: 13px;
    --t: 26px;
    --w: 14px;
    --h: 2px;
    --br: 1px;
    --b: var(--m, var(--normal-mouth));
  }
  .feedback li.ok.active div:before {
    --middle-s-y: .35;
    -webkit-animation: toggle 0.2s linear forwards;
            animation: toggle 0.2s linear forwards;
  }
  .feedback li.ok.active div:after {
    --middle-s-x: .5;
    -webkit-animation: toggle 0.7s linear forwards;
            animation: toggle 0.7s linear forwards;
  }
  .feedback li.good {
    --step-1-rx: -14deg;
    --step-1-rz: 10deg;
    --step-2-rx: 10deg;
    --step-2-rz: -8deg;
  }
  .feedback li.good div:before {
    --b: var(--m, var(--normal-mouth));
    --w: 5px;
    --h: 5px;
    --br: 50%;
    --t: 22px;
    --zi: 0;
    opacity: 0.5;
    box-shadow: 16px 0 0 var(--b);
    filter: blur(2px);
  }
  .feedback li.good div:after {
    --sc: 0;
  }
  .feedback li.good div svg.eye {
    --t: 15px;
    --sc: -1;
    stroke-dasharray: 4.55;
    stroke-dashoffset: 8.15;
  }
  .feedback li.good div svg.mouth {
    --t: 22px;
    --sc: -1;
    stroke-dasharray: 13.3;
    stroke-dashoffset: 23.75;
  }
  .feedback li.good.active div svg.mouth {
    --middle-y: 1px;
    --middle-s: -1;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.happy div {
    --step-1-rx: 18deg;
    --step-1-ry: 24deg;
    --step-2-rx: 18deg;
    --step-2-ry: -24deg;
  }
  .feedback li.happy div:before {
    --sc: 0;
  }
  .feedback li.happy div:after {
    --b: var(--m, var(--normal-mouth));
    --l: 11px;
    --t: 23px;
    --w: 18px;
    --h: 8px;
    --br: 0 0 8px 8px;
  }
  .feedback li.happy div svg.eye {
    --t: 14px;
    --sc: -1;
  }
  .feedback li.happy.active div:after {
    --middle-s-x: .95;
    --middle-s-y: .75;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }

  .feedback li:not(.active) {
    cursor: pointer;
  }

  .feedback li:not(.active):active {
    transform: scale(0.925);
  }
  .feedback li.active {
    --sb: var(--active);
    --sh: var(--active-shadow);
    --m: var(--active-mouth);
    --e: var(--active-eye);
  }
  .feedback li.active div {
    -webkit-animation: shake 0.8s linear forwards;
            animation: shake 0.8s linear forwards;
  }

  @keyframes shake {
    30% {
      transform: perspective(240px) rotateX(var(--step-1-rx, 0deg)) rotateY(var(--step-1-ry, 0deg)) rotateZ(var(--step-1-rz, 0deg)) translateZ(10px);
    }
    60% {
      transform: perspective(240px) rotateX(var(--step-2-rx, 0deg)) rotateY(var(--step-2-ry, 0deg)) rotateZ(var(--step-2-rz, 0deg)) translateZ(10px);
    }
    100% {
      transform: perspective(240px) translateZ(4px);
    }
  }
  @-webkit-keyframes tear {
    0% {
      opacity: 0;
      transform: translateY(-2px) scale(0) translateZ(0);
    }
    50% {
      transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
    }
    20%, 80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
    }
  }
  @keyframes tear {
    0% {
      opacity: 0;
      transform: translateY(-2px) scale(0) translateZ(0);
    }
    50% {
      transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
    }
    20%, 80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
    }
  }
  @-webkit-keyframes toggle {
    50% {
      transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
    }
  }
  @keyframes toggle {
    50% {
      transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
    }
  }
  @-webkit-keyframes angry {
    40% {
      background: var(--active);
    }
    45% {
      box-shadow: inset 3px -3px 4px var(--active-shadow), inset 0 8px 10px var(--active-shadow-angry);
    }
  }
  @keyframes angry {
    40% {
      background: var(--active);
    }
    45% {
      box-shadow: inset 3px -3px 4px var(--active-shadow), inset 0 8px 10px var(--active-shadow-angry);
    }
  }

  html {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  * {
    box-sizing: inherit;
  }
  *:before, *:after {
    box-sizing: inherit;
  }

  #modalCokie {
    z-index: 1;
    position: fixed;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    display: block;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 250000ms 700000ms;
    overflow-x: hidden;
    background-color: rgba(31,32,41,.75);
    align-items: center;
  }

  .encuesta2 {
    z-index: 1;
    position: fixed;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    display: block;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 250000ms 700000ms;
    overflow-x: hidden;
    background-color: rgba(31,32,41,.75);
    align-items: center;
  }

  .cookiesContent {
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    color: #000;
    text-align: center;
    border-radius: 20px;
    padding: 30px 30px 70px;
  }

  .cookiesContent button.close {
    width: 30px;
    font-size: 20px;
    color: #c0c5cb;
    align-self: flex-end;
    background-color: transparent;
    border: none;
    margin-bottom: 10px;
  }

  .cookiesContent img {
    width: 250px;
    margin-bottom: 15px;
  }

  .cookiesContent p {
    margin-bottom: 40px;
    font-size: 18px;
  }

  .cookiesContent button.accept {
    background-color: #ed6755;
    border: none;
    border-radius: 5px;
    width: 200px;
    padding: 14px;
    font-size: 16px;
    color: white;
    box-shadow: 0px 6px 18px -5px #ed6755;
  }

  @media only screen and (max-width: 1026px) {
      #fadeshow1 {
          display: none;
      }
  }

  #page-top {
    padding-right: 0px;
  }

  .progress {
    width: 150px;
    height: 150px;
    background: none;
    position: relative;
  }

  .progress::after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 22px solid #eee;
    position: absolute;
    top: 0;
    left: 0;
  }

  .progress>span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
  }

  .progress .progress-left {
    left: 0;
  }

  .progress .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: 22px;
    border-style: solid;
    position: absolute;
    top: 0;
  }

  .progress .progress-left .progress-bar {
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
  }

  .progress .progress-right {
    right: 0;
  }

  .progress .progress-right .progress-bar {
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
  }

  .progress .progress-value {
    position: absolute;
    top: 0;
    left: 0;
  }

  /*******************************************************************/
  #card-grupo {
    background: rgb(0, 0, 99);
    background: linear-gradient(90deg, rgba(0, 0, 99, 0.8519782913165266) 9%, rgba(9, 75, 121, 0.8407738095238095) 44%, rgba(185, 242, 255, 1) 100%);
    color: #FFF !important;
  }

  /******************************************************************/
  #chartdiv {
    width: 100%;
    height: 130px;
  }

  /*
  *
  * ==========================================
  * FOR DEMO PURPOSE
  * ==========================================
  *
  */

  body {
    background: #ff7e5f;
    background: -webkit-linear-gradient(to right, #ff7e5f, #feb47b);
    background: linear-gradient(to right, #ff7e5f, #feb47b);
    min-height: 100vh;
    padding-right: 0px !important;
  }

  .rounded-lg {
    border-radius: 1rem;
  }

  .text-gray {
    color: #aaa;
  }

  div.h4 {
    line-height: 1rem;
  }

  .scroll {
    overflow-y: hidden;
  }
</style>